export default {
  DISCORD: 'https://www.discord.com/invite/sMzHHnFkTh/',
  INSTAGRAM: 'https://www.instagram.com/allesimrudel/',
  FACEBOOK: 'https://www.facebook.com/allesimrudel/',
  YOUTUBE: 'https://www.youtube.com/channel/UCPNIzEtVBgS5cu6ak_FkjDQ',
  TWITCH: 'https://www.twitch.tv/allesimrudel/',
  AIRSOFT_VERZEICHNIS: 'https://www.airsoft-verzeichnis.de/index.php?status=team&teamnummer=011712'
};